import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
    { path: '', redirectTo: '/app/dashboard', pathMatch: 'full' },
    {
        path: 'account',
        loadChildren: () => import('./app/account/account.module').then((m) => m.default),
        data: { preload: true },
    },
    { path: '**', redirectTo: '/app/dashboard' },
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        scrollPositionRestoration: 'disabled',
        anchorScrolling: 'enabled',
    })],
    exports: [RouterModule],
})
export class RootRoutingModule {}
